import Struct, { placeholder } from "@yume-chan/struct";
import { ScrcpyBackOrScreenOnEvent1_16, ScrcpyOptions1_16 } from "./1_16/index.js";
export const ScrcpyBackOrScreenOnEvent1_18 = new Struct()
    .fields(ScrcpyBackOrScreenOnEvent1_16)
    .uint8('action', placeholder());
export class ScrcpyOptions1_18 extends ScrcpyOptions1_16 {
    constructor(value) {
        super(value);
    }
    getArgumentOrder() {
        return super.getArgumentOrder().concat(['powerOffOnClose']);
    }
    getDefaultValue() {
        return Object.assign(Object.assign({}, super.getDefaultValue()), { powerOffOnClose: false });
    }
    getOutputEncoderNameRegex() {
        return /\s+scrcpy --encoder '(.*?)'/;
    }
    serializeBackOrScreenOnControlMessage(message) {
        return ScrcpyBackOrScreenOnEvent1_18.serialize(message);
    }
}
//# sourceMappingURL=1_18.js.map